"use client";

import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { POPOVER_ARROW_PATH } from "./QFL5V2DO.js";
import { usePopoverContext } from "./COWZSPJ7.js";
import { createElement, createHook, forwardRef } from "./7FZLUSKW.js";
import { useMergeRefs, useSafeLayoutEffect } from "./HNHAUIIY.js";
import { __objRest, __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/popover/popover-arrow.tsx
import { getWindow } from "@ariakit/core/utils/dom";
import { invariant, removeUndefinedValues } from "@ariakit/core/utils/misc";
import { useMemo, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var TagName = "div";
var defaultSize = 30;
var halfDefaultSize = defaultSize / 2;
var rotateMap = {
  top: "rotate(180 ".concat(halfDefaultSize, " ").concat(halfDefaultSize, ")"),
  right: "rotate(-90 ".concat(halfDefaultSize, " ").concat(halfDefaultSize, ")"),
  bottom: "rotate(0 ".concat(halfDefaultSize, " ").concat(halfDefaultSize, ")"),
  left: "rotate(90 ".concat(halfDefaultSize, " ").concat(halfDefaultSize, ")")
};
function useComputedStyle(store) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    style = _useState2[0],
    setStyle = _useState2[1];
  var contentElement = store.useState("contentElement");
  useSafeLayoutEffect(function () {
    if (!contentElement) return;
    var win = getWindow(contentElement);
    var computedStyle = win.getComputedStyle(contentElement);
    setStyle(computedStyle);
  }, [contentElement]);
  return style;
}
var usePopoverArrow = createHook(function usePopoverArrow2(_a) {
  var _b = _a,
    store = _b.store,
    _b$size = _b.size,
    size = _b$size === void 0 ? defaultSize : _b$size,
    props = __objRest(_b, ["store", "size"]);
  var context = usePopoverContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "PopoverArrow must be wrapped in a Popover component.");
  var dir = store.useState(function (state) {
    return state.currentPlacement.split("-")[0];
  });
  var style = useComputedStyle(store);
  var fill = (style == null ? void 0 : style.getPropertyValue("background-color")) || "none";
  var stroke = (style == null ? void 0 : style.getPropertyValue("border-".concat(dir, "-color"))) || "none";
  var borderWidth = (style == null ? void 0 : style.getPropertyValue("border-".concat(dir, "-width"))) || "0px";
  var strokeWidth = Number.parseInt(borderWidth) * 2 * (defaultSize / size);
  var transform = rotateMap[dir];
  var children = useMemo(function () {
    return /* @__PURE__ */jsx("svg", {
      display: "block",
      viewBox: "0 0 30 30",
      children: /* @__PURE__ */jsxs("g", {
        transform: transform,
        children: [/* @__PURE__ */jsx("path", {
          fill: "none",
          d: POPOVER_ARROW_PATH
        }), /* @__PURE__ */jsx("path", {
          stroke: "none",
          d: POPOVER_ARROW_PATH
        })]
      })
    });
  }, [transform]);
  props = __spreadProps(__spreadValues({
    children: children,
    "aria-hidden": true
  }, props), {
    ref: useMergeRefs(store.setArrowElement, props.ref),
    style: __spreadValues({
      // server side rendering
      position: "absolute",
      fontSize: size,
      width: "1em",
      height: "1em",
      pointerEvents: "none",
      fill: fill,
      stroke: stroke,
      strokeWidth: strokeWidth
    }, props.style)
  });
  return removeUndefinedValues(props);
});
var PopoverArrow = forwardRef(function PopoverArrow2(props) {
  var htmlProps = usePopoverArrow(props);
  return createElement(TagName, htmlProps);
});
export { usePopoverArrow, PopoverArrow };